<!-- PaymentIndex.vue -->
<template>
  <SubNavCardVue :buttons="buttons">
    <router-view></router-view>
  </SubNavCardVue>
</template>
<script>
import SubNavCardVue from '@/components/cards/SubNavCard.vue'
export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        // Paiements clients
        {
          label: 'Paiements Clients',
          icon: 'bi bi-credit-card',
          route: 'payments-customers-index'
        },
       
        // Paiements fournisseurs
        {
          label: 'Paiements Fournisseurs',
          icon: 'bi bi-wallet2',
          route: 'payments-suppliers-index'
        },
        
      ]
    }
  }
}
</script>